import type { TranslationsGetRequestBody } from '@/server/api/rest/translations';
import { fetchTranslations } from '@/shared/api/translation/fetch-translations.api';
import type { GetContentTranslations } from '@embira/translations';
import { useQuery } from '@tanstack/react-query';

type UseDatabaseTranslationsProps = TranslationsGetRequestBody & {
  enabled?: boolean;
};

export const useDatabaseTranslations = ({
  model,
  fields,
  foreignKeys,
  locale,
  enabled,
}: UseDatabaseTranslationsProps) => {
  return useQuery<GetContentTranslations>({
    queryKey: ['translations', 'model', 'fields', 'foreignKeys'],
    queryFn: () =>
      fetchTranslations({
        model,
        fields,
        foreignKeys,
        locale,
      }),
    enabled,
  });
};
